var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarRangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4311 1.40234H14.5834V2.21496C14.5834 2.92614 14.0477 3.51527 13.4009 3.51527C12.7541 3.51527 12.2184 2.94639 12.2184 2.21496V1.40234H6.7677V2.21496C6.7677 2.92614 6.25034 3.51527 5.58518 3.51527C4.93842 3.51527 4.40265 2.94639 4.40265 2.21496V1.40234H2.55497C1.5387 1.40234 0.707275 2.31659 0.707275 3.43407V15.2587C0.707275 16.3762 1.5387 17.2905 2.55497 17.2905H16.4126C17.4289 17.2905 18.2603 16.3762 18.2603 15.2587V3.43407C18.2788 2.31659 17.4473 1.40234 16.4311 1.40234H16.4311ZM17.2625 15.2587C17.2625 15.7667 16.893 16.173 16.4311 16.173H2.57344C2.11152 16.173 1.74201 15.7667 1.74201 15.2587V5.85183H17.2626L17.2625 15.2587Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60318 2.78354C5.88028 2.78354 6.10209 2.53978 6.10209 2.23494V0.548603C6.10209 0.243902 5.8804 0 5.60318 0C5.32608 0 5.10427 0.243764 5.10427 0.548603V2.23494C5.08584 2.53978 5.32608 2.78354 5.60318 2.78354Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.401 2.78354C13.6781 2.78354 13.8999 2.53978 13.8999 2.23494V0.548603C13.8999 0.243902 13.6782 0 13.401 0C13.1239 0 12.9021 0.243764 12.9021 0.548603V2.23494C12.9021 2.53978 13.1239 2.78354 13.401 2.78354Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarRangeIcon);
export default __webpack_public_path__ + "static/media/calendar_range_icon.619eaca0d509d66024b3f8d9380d787a.svg";
export { ForwardRef as ReactComponent };